import {
    DataTable,
    DataTablePresenter,
    ITableColumn,
    ProviderMissingEvidence,
    TitleCard,
} from '@enter/core';
import React, { useMemo } from 'react';
import styled from '@emotion/styled/macro';

const StyledTitleCard = styled(TitleCard)`
    justify-content: space-between;
    max-width: 100%;
`;

const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
`;

const StyledDataTable = styled(DataTable)`
    display: flex;
    flex-direction: column;
    margin: 16px 0;
    flex: 1 1 100%;
    box-shadow: 0 0.5px 0 0 #e5e5e5;

    [role='columnheader'] {
        padding: 8px 12px 6px 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    [role='cell'] {
        display: inline-block;
        padding: 8px 12px 6px 12px;
        line-height: 24px;
        font-size: 15px;
        color: #666;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

interface IMissingEvidenceTableProps {
    data: ProviderMissingEvidence[];
    isLoading?: boolean;
}

export const MissingEvidenceTable: React.FC<IMissingEvidenceTableProps> = ({
    data,
    isLoading = false,
}) => {
    const columns: ITableColumn<ProviderMissingEvidence>[] = useMemo(() => [
        {
            id: 'name',
            Header: 'Name',
            accessor: 'evidenceType',
            Cell: ({ value }) => <span style={{ fontWeight: '500' }}>{value?.name || 'N/A'}</span>,
            minWidth: 200,
        },
        {
            id: 'description',
            Header: 'Description',
            accessor: 'evidenceType',
            Cell: ({ value }) => <span>{value?.description || 'N/A'}</span>,
            minWidth: 300,
        },
    ], []);

    const presenter = useMemo(() => new DataTablePresenter({
        name: 'missingEvidence',
        data: data,
        columns: columns,
        filterSchemas: [],
    }), [data, columns]);

    return (
        <StyledTitleCard
            size="large"
            title="Missing Evidence"
        >
            <CardBody>
                <StyledDataTable
                    presenter={presenter}
                    isLoading={isLoading}
                    disableSorting={false}
                    hideFiltering={true}
                    hideNavigation={true}
                    hidePagination={true}
                    hideSettings={true}
                />
            </CardBody>
        </StyledTitleCard>
    );
};

